'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

import ErrorPage from '@/components/ErrorPage';

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
    useEffect(() => {
        // Log the error to Sentry
        Sentry.captureException(error);
    }, [error]);

    return <ErrorPage onReset={reset} />;
}
